const topics = [
  {
    title: '热播电视剧',
    desc: '追踪当下最火剧集',
    count: '128部',
    icon: 'ri-tv-2-line',
    color: 'primary',
  },
  {
    title: '高分电影',
    desc: '豆瓣8.0以上精选',
    count: '356部',
    icon: 'ri-film-line',
    color: 'accent',
  },
  {
    title: '热门综艺',
    desc: '娱乐综艺一网打尽',
    count: '94档',
    icon: 'ri-emotion-line',
    color: 'secondary',
  },
  {
    title: '动漫番剧',
    desc: '国漫日漫同步追更',
    count: '212部',
    icon: 'ri-ghost-smile-line',
    color: 'primary',
  },
  {
    title: '纪录片库',
    desc: '自然人文知识盛宴',
    count: '189部',
    icon: 'ri-earth-line',
    color: 'accent',
  },
  {
    title: '港剧经典',
    desc: 'TVB与亚视怀旧',
    count: '276部',
    icon: 'ri-building-2-line',
    color: 'secondary',
  },
  {
    title: '韩剧精选',
    desc: '高分韩剧全集收录',
    count: '163部',
    icon: 'ri-heart-line',
    color: 'primary',
  },
  {
    title: '少儿频道',
    desc: '亲子动画寓教于乐',
    count: '305部',
    icon: 'ri-bear-smile-line',
    color: 'accent',
  },
];

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  primary: { bg: 'bg-primary-50', text: 'text-primary-600', border: 'border-primary-200/60' },
  accent: { bg: 'bg-accent-50', text: 'text-accent-600', border: 'border-accent-200/60' },
  secondary: { bg: 'bg-secondary-50', text: 'text-secondary-600', border: 'border-secondary-200/60' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            八大专题频道，快速找到你想看的内容类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {topics.map((topic, i) => {
            const c = colorMap[topic.color];
            return (
              <a
                key={i}
                href="#carousel"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className={`group flex flex-col items-center text-center p-5 md:p-6 rounded-2xl border ${c.border} ${c.bg} hover:scale-[1.02] transition-all duration-300 cursor-pointer no-underline`}
              >
                <div className={`w-12 h-12 rounded-xl ${c.bg} flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${topic.icon} text-xl ${c.text}`}></i>
                </div>
                <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-1">{topic.title}</h3>
                <p className="text-xs text-foreground-500 mb-2">{topic.desc}</p>
                <span className={`text-xs font-medium ${c.text}`}>{topic.count}</span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}